module.exports = __webpack_public_path__ + "img/vz_150_rgb_p.png";